<template>


    <div class="page-content">   
		<div data-height="150" class="page-title-bg bg-20"><!-- image --></div>
		<div data-height="150" class="page-title-bg dark-mode-tint"><!-- contrast for dark mode --></div>
		<div data-height="150" class="page-title-bg opacity-90 bg-highlight"><!-- background color --></div>
		
		<div class="page-title-small color-white bottom-30">
			<h1><i class="fa fa-arrow-left back-button"></i>Ingreso inventario del vehículo ( OT {{ idcotizacionvehiculo }})</h1>
			<a href="/dashboard" data-menu="menu-main" class="shadow-huge scale-box bg-fade-gray2-dark" v-bind:style="userimageurl"></a>
		</div>
	

    	<div id='content1'>   
		 	<form onsubmit="event.preventDefault();" id="Formsubmit">
				<div class="divider bottom-15">
				</div>
				<div class="content-boxed">
					<div class="content-boxed">
						<div class="content">
							<div v-if="!c.eslistasino && !c.cols" v-for="(c, index) in caracteristicas" class="content-boxed shadow-large bg-mint-light">
								<div class="content bottom-0">
									<h3 class="bolder">{{ c.descripcion }}</h3>
									<p>
									<span v-if="c.cols">
										<input type=hidden v-bind:name="c.iddtype" v-bind:id="c.iddtype" v-bind:value="c.tipocampo">
										<textarea type=input class='form-control'  v-bind:id="c.iddfield" v-bind:name="c.iddfield" v-bind:rows="7" v-bind:cols="c.cols" style="width:100%">{{ c.value.replace(/<br>/g,'\n') }}</textarea>
									</span>

									<input type="hidden" v-bind:id="c.id" v-bind:name="c.name" value=''>
									<span v-if="c.requerido" v-bind:id="'r_mt_cbo_'+c.codtipocaracteristica" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Dato requerido</span>
									</p>

									<div v-bind:id="'lista_'+c.id" v-if="c.eslista" class="row">
										<input type="hidden"  v-bind:id="'mt_cbo_'+c.codtipocaracteristica" v-bind:name="'mt$cbo_'+c.codtipocaracteristica" v-bind:value='c.listaselectedvalue'>
										<span v-for="(l, index) in c.lista">
											<span v-if="c.listaselectedvalue">
												<button v-if="l.selected" v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-orange-dark">{{ l.text }}</button>
												<button v-else v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-gray2-light">{{ l.text }}</button>
											</span>
											<span v-else>
												<button v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-orange-light">{{ l.text }}</button>
											</span>
										</span>
									</div>
								</div>   
							</div>
						</div>
					</div>

					<div class="content-boxed">
						<div class="content">
							<div class="content-boxed shadow-large last-column bg-green2-light">
								<span>
									<button @click="selectSi()" class="button button-s shadow-small button-circle bg-orange-dark">Todos Sí</button>
								</span>
								<span>
									<button @click="selectNo()" class="button button-s shadow-small button-circle bg-orange-dark">Todos No</button>
								</span>
							</div>
						</div>
					</div>

					<div class="content-boxed">
						<div class="content">
							<div v-if="c.eslistasino && !c.cols" v-for="(c, index) in caracteristicas" class="content-boxed shadow-large one-half last-column bg-green2-light">
								<div class="content bottom-0">
									<h3 class="bolder">{{ c.descripcion }}</h3>
									<p>

									<input type="hidden" v-bind:id="c.id" v-bind:name="c.name" value=''>
									<span v-if="c.requerido" v-bind:id="'r_mt_cbo_'+c.codtipocaracteristica" style="display:none" class="bg-red2-dark center-text uppercase color-white ultrabold">Dato requerido</span>
									</p>
									<div v-bind:id="'lista_'+c.id" v-if="c.eslista" class="row">
										<input type="hidden"  v-bind:id="'mt_cbo_'+c.codtipocaracteristica" v-bind:name="'mt$cbo_'+c.codtipocaracteristica" v-bind:value='c.listaselectedvalue'>
										<span v-for="(l, index) in c.lista">
											<span v-if="c.listaselectedvalue">
												<button v-if="l.selected" v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-orange-dark">{{ l.text }}</button>
												<button v-else v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-gray2-light">{{ l.text }}</button>
											</span>
											<span v-else>
												<button v-bind:id="'mt_itemcbo_'+c.codtipocaracteristica+'_sel_'+index" @click="seleccioncaracteristica(c.codtipocaracteristica,index,l.value)" class="button button-s shadow-small button-circle bg-orange-light">{{ l.text }}</button>
											</span>
										</span>
									</div>
								</div>   
							</div>
						</div>
					</div>
							

					<div class="content-boxed">
							<a href="#" class="button bg-blue2-dark button-m button-full round-small bottom-10 shadow-small contactSubmitButton" @click="siguiente" data-formId="dataForm">Siguiente</a>
					</div>

				</div>   
 			</form>
    	</div>
    </div>


</template>

<script>

import * as db from "./../../database.js";
import * as validate from "./../../validate.js";

export default {
  data() {
      return {
		params:'{"valkey":"'+localStorage.getItem('idcotizacionvehiculo')+'","tablename":"T_VEH_COTIZACIONVEHICULO","entity":"8","classifications":"39,40"}',
		idcotizacionvehiculo: localStorage.getItem('idcotizacionvehiculo'),
		idagenda:localStorage.getItem('idagenda'),
		userimageurl:"background-image:url("+db.getServerHTTP()+JSON.parse(localStorage.getItem('user')).imageurl+")",  
		codsucursal:JSON.parse(localStorage.getItem('user')).codsucursal,
		sucursal:JSON.parse(localStorage.getItem('user')).sucursal,

		caracteristicas:[]
		}
    },

	created() {    

		db.getFx("ot.getcaracteristicas",this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
			console.log(result)
			this.caracteristicas=result.data.data
		 }});


},


  methods: {
		seleccioncaracteristica(codcaracteristica,index,value)
			{
				//Ver Codigos de los Botones
				// console.log("CodCaracteristica: " +codcaracteristica)
				// console.log("Index: " + index)
				// console.log("Value: " + value)
				document.getElementById("mt_cbo_"+codcaracteristica).value=value
				document.getElementById("mt_itemcbo_"+codcaracteristica+"_sel_"+index).className="button button-s shadow-small button-circle bg-orange-dark"

			var intLen=document.getElementById("lista_mt_txtID_"+codcaracteristica).children.length;

			var i;
			for (i=0;i<intLen-1;i++)
				if(i!=index)
					document.getElementById("mt_itemcbo_"+codcaracteristica+"_sel_"+i).className="button button-s shadow-small button-circle bg-gray2-light"
			
			return false;
			},
			
			
		siguiente()
	  	{
		var strErr=validate.check(Formsubmit)
		if (strErr=="")
			{
			db.sendDataForm(Formsubmit,this.params)   .then(result => {if (result.data.err!=""){alert(result.data.err);console.log (result.data.err);}else{
				window.location="/Wizardot4draw"
			}});
			}
		},
		selectSi() {

			let url = db.getServerHTTP()

			if (url.startsWith("https://preproduccionxxi.netcar.cl/")) {
				
				let select = 839;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if (url.startsWith("https://puente.xxi.cl/")) {
				
				let select = 839;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if (url.startsWith("https://netcar3.xxi.cl/")) {

				let select = 839;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if (url.startsWith("https://puente.valenzueladelarze.cl/")) {
				
				let select = 366;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1599 && c.codtipocaracteristica !== 1898) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}

			}

			if (url.startsWith("http://netcar3.valdelarze.cl/")) {
				
				let select = 366;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1599 && c.codtipocaracteristica !== 1898) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}

			}

			//Portillo
			if (url.startsWith("http://qa.netcarportillosur.com/")) {
				
				let select = 366;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 3203) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}

			}
			
        },
		selectNo() {

			let url = db.getServerHTTP()

			if(url.startsWith("https://preproduccionxxi.netcar.cl/")){

				let select = 840;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if(url.startsWith("http://puente.xxi.cl/") || url.startsWith("https://puente.xxi.cl/")){

				let select = 840;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if(url.startsWith("http://netcar3.xxi.cl/")){
				
				let select = 840;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1660) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if(url.startsWith("https://puente.valenzueladelarze.cl/")){
				
				let select = 367;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1599 && c.codtipocaracteristica !== 1898) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if(url.startsWith("http://netcar3.valdelarze.cl/")){
				
				let select = 367;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 1599 && c.codtipocaracteristica !== 1898) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}

			if(url.startsWith("http://qa.netcarportillosur.com/")){

				let select = 367;

				for (let c of this.caracteristicas) {
					if (c.eslista && c.codtipocaracteristica !== 3203) {
						document.getElementById("mt_cbo_" + c.codtipocaracteristica).value = select;
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_1").className = "button button-s shadow-small button-circle bg-orange-dark";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_2").className = "button button-s shadow-small button-circle bg-gray2-light";
						document.getElementById("mt_itemcbo_" + c.codtipocaracteristica + "_sel_0").className = "button button-s shadow-small button-circle bg-gray2-light";
					}
				}
			}
        }

  }
}

</script>
